import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export enum FeatureFlags {
  Default, // Used for default assignment of feature flag variables. Always returns true.
  NFP2019,
  ShowFrontPageBanner,
}

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  constructor() { }

  featureEnabled(flag: FeatureFlags): boolean {
    switch (flag) {
      case FeatureFlags.Default:
        return true;
      case FeatureFlags.NFP2019:
        return environment.featureClientEnableNFP2019Code;
      case FeatureFlags.ShowFrontPageBanner:
        return environment.featureShowFrontPageBanner ?? false;
      default:
        throw 'Unknown feature flag!';
    }
  }
}
